import { PrestadorEntry } from '../entrys/prestador.entry';

export class PrestadorModel implements PrestadorEntry {
  	numero_identificacion_representante_legal: string;
	numero_empleados: string;
	patrimonio_neto: number;
	tipo_prestador: string;
	codigo_camara: string;
	prestador_id: number;
	tipo_prestador_id: number;
	usuario_id: number;
	usuario: string;
	clave_acceso: string;
	nombre_representante_legal: string;
	tipo_identificacion_id: string;
	numero_identificacion: string;
	nit: string;
	digito_verificacion: number;
	correo_electronico: string;
	permite_recibir_notificaciones: true;
	orden: number;
	activo: boolean;
	desc_tipo_identificacion: string;
	razon_social: string;
	correo_electronico_reportado: string;
	telefono_reportado_1: string;
	telefono_reportado_2: string;
	usuario_auditoria: string;
	correo_electronico_fiscal: string;
	ultimo_ano_renovado: string;
	es_caja_compensacion: boolean;
	numero_certificado: string;
}
